import { Configs } from "./index";
import Web3 from "web3";

const INFOCHAIN = {
  DOS: {
    TOKEN_USDC: '0x2787E8f18da4FC2113268ce8521B7A53df2D5c35',
  },
  AVAX: {
    TOKEN_USDC: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
  },
  BSC: {
    TOKEN_USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
  }

}

const configs: Configs = {
  CLIENT: "mainnet",
  API_URI: "",
  NETWORKS: {
    AVAX: {
      chainId: Web3.utils.numberToHex(43114),
      rpcUrls: ["https://api.avax.network/ext/C/rpc"],
      chainName: "Avalanche Network C-Chain",
      blockExplorerUrls: ["https://snowtrace.io"],
      nativeCurrency: {
        name: "AVAX",
        symbol: "AVAX",
        decimals: 18,
      },
    },
    BSC: {
      chainId: Web3.utils.numberToHex(56),
      rpcUrls: ["https://bscrpc.com"],
      chainName: "Binance Smart Chain Mainnet",
      blockExplorerUrls: ["https://bscscan.com"],
      nativeCurrency: {
        name: "BNB",
        symbol: "BNB",
        decimals: 18,
      },
    },
    DOS: {
      chainId: Web3.utils.numberToHex(7979),
      rpcUrls: ["https://main.doschain.com"],
      chainName: "DOS",
      blockExplorerUrls: ["https://doscan.io"],
      nativeCurrency: {
        name: "DOS Chain",
        symbol: "DOS",
        decimals: 18,
      },
    }
  },
  DEFAULT_CHAIN: "AVAX",

};
export default configs;



